import {
  Card,
  CardContent,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Table,
  TableBody,
  TableContainer,
  Tabs,
  TextField,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import SearchIcon from '@material-ui/icons/Search';
import React, { useEffect, useState } from 'react';
import { Pagination } from '../../components/Table';
import { privateApi } from '../../lib/privateApi';
import { AgentLayout as Layout, Banner } from '../../components/Portal';
import { formatDate } from '../../utils/commonUtils';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    overflowX: 'auto'
  },
  tableHead: {
    backgroundColor: '#F4F6F8',
    color: '#01305F',
    padding: '15px',

  },
});

export const AgentActionItemsFilter: object[] = [
  {
    id: 'ALL',
    name: 'All'
  },
  {
    id: 'SIGN_AGENT',
    name: 'View and Sign'
  },
  {
    id: 'VIEW_APPROVE',
    name: 'View and Approve'
  }
];

const actionItems = () => {
  const [value, setValue] = React.useState(0);
  const classes = useStyles();

  const [orderBy, setOrderBy] = useState('createdAt');
  const order = 'desc';
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [filterType, setFilterType] = useState('ALL');
  const [searchText, setSearchText] = useState('');
  const [actionItemsList, setActionItemsList] = useState({rows: []});

  const handleChange = (_event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
    if (newValue === 0 && orderBy === 'updatedAt') {
      setOrderBy('createdAt');
    }
    if (newValue === 1 && orderBy === 'createdAt') {
      setOrderBy('updatedAt');
    }
  };

  const getActionList = async () => {
    const filter = 2;
    const trancheNo = 0;

    const response = await privateApi.get(`/account/agent/actionlist`, {
      params: {
        page,
        rowsPerPage,
        searchText,
        filter,
        sortBy: orderBy,
        order,
        type: value,
        status: value,
        filterType,
        trancheNo
      }
    })
    setActionItemsList(response.data)
  }

  useEffect(() => {
    getActionList()
  }, [page, rowsPerPage, searchText, orderBy, order, value, filterType])

  let actionItemsListData: any = actionItemsList.rows && actionItemsList.rows.length > 0 && actionItemsList.rows.map((row: any) => {
    row.agent = row.agent ? row.agent : (row.client && row.client.agent ? row.client.agent : null);
    return row;
  });

  const getRole = (role: number) => {
    if (role == 1 || role === 2) {
      return 'Admin';
    }
    if (role == 3) {
      return 'Imo';
    }
    if (role == 4) {
      return 'Agent';
    }
    if (role == 12) {
      return 'Trustee';
    }
    return 'Client';
  };

  const getActionName = (actionItem: any) => {
    let actionRequired: string = actionItem.actionRequired;
    if (actionItem && actionItem.enrollmentNotes && actionItem.enrollmentNotes.author) {
      actionRequired += ' - ' + actionItem.enrollmentNotes.author.firstName + ' ' + actionItem.enrollmentNotes.author.lastName + ' (' + getRole(actionItem.enrollmentNotes.author.role) + ')';
    }
    return actionRequired;
  };

  return (
    <Layout>
      <Grid container spacing={2}>
        <Banner title="Action Items" description={''} />
        <Grid container spacing={4}>
          <Grid item>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12} lg={6}>
                <Tabs
                  className="actionItemsTabs"
                  value={value}
                  variant="scrollable"
                  onChange={handleChange}
                  indicatorColor="secondary"
                  textColor="secondary"
                  aria-label="icon label tabs example"
                >
                  <Tab icon={<HourglassEmptyIcon />} label="Pending Action Items" />
                  <Tab icon={<DoneAllIcon />} label="Completed Action Items" />
                </Tabs>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <FormControl className="mt15" variant="outlined" fullWidth={true}>
                  <InputLabel id="action-select-label">Filter</InputLabel>
                  <Select
                    value={filterType} onChange={e => {
                    let val: any = e.target.value;
                    setFilterType(val);
                  }} labelId="action-select-label" label="Action" fullWidth
                  >
                    {
                      AgentActionItemsFilter.map((item: any) =>
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>)
                    }
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <TextField
                  className="mt15"
                  placeholder={'Search'}
                  fullWidth
                  variant={'outlined'}
                  value={searchText}
                  onChange={e => {
                    setPage(0);
                    setSearchText(e.target.value);
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton className="iconBtn" aria-label="search">
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Card>
                  <CardContent>
                    <TableContainer className="mt20">
                      <Table className={classes.table} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell className={classes.tableHead}>Client Name</TableCell>
                            <TableCell className={classes.tableHead}>Action Item</TableCell>
                            <TableCell className={classes.tableHead}>Date Added</TableCell>
                            <TableCell className={classes.tableHead}>Action Needed</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {
                            (!actionItemsListData || actionItemsListData.length === 0)
                            &&
                            <TableRow>
                              <TableCell colSpan={4}>
                                <Typography variant="caption">
                                  No Data
                                </Typography>
                              </TableCell>
                            </TableRow>
                          }
                          {actionItemsListData && actionItemsListData.map((actionItem: any) => {
                            return (
                              <TableRow hover key={actionItem.id}>
                                <TableCell>
                                  {actionItem.client.user.firstName + ' ' + actionItem.client.user.lastName}
                                </TableCell>
                                <TableCell>
                                  {
                                    getActionName(actionItem)
                                  }
                                </TableCell>
                                <TableCell>{formatDate(actionItem.status === 0 ? actionItem.createdAt : actionItem.updatedAt)}</TableCell>
                                <TableCell />
                                {/* <TableCell>
                                  {actionItem.actionType === "VIEW_APPROVE" ?
                                          <Button
                                                  size="small"
                                                  variant="contained"
                                                  color="primary"
                                                  onClick={() => {
                                                      viewProposal(actionItem.id, actionItem.enrollmentId, actionItem.status, actionItem.client);
                                                  }}
                                          >
                                              {actionItem.status === 0 ? "View and Approve Proposal" : "View Proposal"}
                                          </Button>
                                          :
                                          <Button
                                                  size="small"
                                                  variant="outlined"
                                                  color="primary"
                                                  onClick={() => {
                                                      actionItem.status === 0 ? getEnvelope(actionItem.enrollmentId) : getEnvelope(actionItem.enrollmentId, 2);
                                                  }}
                                          >
                                              {actionItem.status === 0 ?
                                                      actionItem && actionItem.client && actionItem.client.strategy && actionItem.client.strategy.slug !== cashStreamSlug ? "Sign Application Docs" : "Approve Application Docs"
                                                      : "Signed Application (View)"}
                                          </Button>
                                  }
                                  {CurrentActionsItems.VIEW_APPROVE.actionType === actionItem.actionType && actionItem.status === 0 &&
                                  <Button
                                          size="small"
                                          variant="outlined"
                                          color="primary"
                                          className="btnSmall"
                                          type={"button"}
                                          onClick={() => handleRequestModification(actionItem.enrollmentId)}
                                  >
                                      Request Modification
                                  </Button>
                                  }
                              </TableCell> */}
                              </TableRow>
                            );
                          })
                          }
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <Pagination
                      page={Number(page)}
                      rowsPerPage={Number(rowsPerPage)}
                      setPage={setPage}
                      setRowsPerPage={setRowsPerPage}
                      list={actionItemsList}
                    />
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Layout>
  )
}

export default actionItems;
